import {PickupModalContext} from 'modules/products/context/PickupModal';
import {useAddExpressOrderMutation} from 'modules/products/services';
import {IWineShop} from 'modules/wineshops-list/models';
import {useGetWineShopListQuery} from 'modules/wineshops-list/services';
import React, {FC, ReactNode, useCallback, useContext, useMemo} from 'react';
import {hideModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import {IExpressOrder} from 'plugins/modules/filter/types';

interface IProps {
    children: ReactNode;
}

export const FilterPickupModalProvider: FC<IProps> = ({children}) => {
    const {setWineShop, handleResetPagination} = useContext(FilterPickupTodayButtonContext);

    const dispatch = useAppDispatch();
    const [addExpressOrder] = useAddExpressOrderMutation();
    const wineShopsResponseData = useGetWineShopListQuery();

    const closeModal = useCallback(() => {
        dispatch(hideModal(MODALS.EXPRESS_ORDER.name));
    }, [dispatch]);

    const handleSuccess = useCallback(
        (wineShop: IExpressOrder) => {
            setWineShop?.(wineShop);
            closeModal();
        },
        [closeModal, setWineShop],
    );

    const wineShopList = useMemo(() => {
        const data = wineShopsResponseData?.data?.data;

        if (!data) {
            return [];
        }

        return data.items;
    }, [wineShopsResponseData]);

    const handleSelectShop = useCallback(
        async (wineShop: IWineShop) => {
            try {
                const response = await addExpressOrder({
                    idVinoteki: Number(wineShop.id),
                });

                if ('error' in response) {
                    return;
                }

                const {data, ok} = response.data;

                if (!ok) {
                    return;
                }
                handleSuccess(data);
                handleResetPagination?.();
            } catch (e) {
                console.error(e);
            }
        },
        [addExpressOrder, handleResetPagination, handleSuccess],
    );

    const value = useMemo(() => {
        return {
            isMapButtonShow: true,
            mapButtonTitle: 'Заберу отсюда',
            onSelectShop: handleSelectShop,
            wineShopList,
        };
    }, [handleSelectShop, wineShopList]);

    return <PickupModalContext.Provider value={value}>{children}</PickupModalContext.Provider>;
};
